import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_NEWS = "GET_LIST_NEWS";
export const GET_DETAIL_NEWS = "GET_DETAIL_NEWS";
export const SAVE_NEWS = "SAVE_NEWS";
export const DELETE_NEWS = "DELETE_NEWS";
export const UPDATE_NEWS = "UPDATE_NEWS";
export const UPLOAD_IMAGE_NEWS = "UPLOAD_IMAGE_NEWS";
export const SET_LIST_NEWS = "SET_LIST_NEWS";
export const SET_DETAIL_NEWS = "SET_DETAIL_NEWS";



const state = {
    news: [],
    newsDetail: [],
};

const getters = {
    news(state) {
        return state.news;
    },
    newsDetail(state) {
        return state.newsDetail;
    },
};

const actions = {
    [GET_LIST_NEWS](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_NEWS}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_NEWS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_NEWS](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_NEWS}/${id}`).then(({ data }) => {
                console.log(data.data)
                if (data.status) {
                    context.commit(SET_DETAIL_NEWS, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_NEWS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_NEWS}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_IMAGE_NEWS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_NEWS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_NEWS}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_NEWS](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_NEWS}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_NEWS](state, data) {
        state.news = data.data;
    },
    [SET_DETAIL_NEWS](state, data) {
        state.newsDetail = data.data;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};